import { render, staticRenderFns } from "./BlockRegisterUserInfo.vue?vue&type=template&id=359e2a27&"
import script from "./BlockRegisterUserInfo.vue?vue&type=script&lang=js&"
export * from "./BlockRegisterUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports